( function( app ) {
  const COMPONENT = {
    init: function() {
      const sections = document.querySelectorAll( '.image-cta' );
      if ( !sections.length ) return;

      const io = new IntersectionObserver( ( entries ) => {
        entries.forEach( ( entry ) => {
          if ( !entry.isIntersecting ) return;

          entry.target.classList.add( 'is-visible' );

          io.unobserve( entry.target );
        } );
      }, {
        threshold: 0.2,
        rootMargin: '0px 0px -10% 0px',
      } );

      sections.forEach( ( section ) => {
        if ( section.dataset.ioBound === 'true' ) return;

        section.dataset.ioBound = 'true';
        io.observe( section );
      } );
    },
  };
  app.registerComponent( 'image-cta', COMPONENT );
} )( app );
